import React, { useState } from "react";
import "../style/Contact.css";
import { toast } from "react-toastify";
import { motion } from "motion/react";

const PhoneIcon = () => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.362 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
    </svg>
);

const MailIcon = () => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <rect x="2" y="4" width="20" height="16" rx="2" />
        <path d="m22 6-10 7L2 6" />
    </svg>
);

const PinIcon = () => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
        <circle cx="12" cy="10" r="3" />
    </svg>
);

const ArrowIcon = () => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M4 12h15M13 6l6 6-6 6" />
    </svg>
);

const Contact = ({ contact_key }) => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        message: "",
    });

    const [result, setResult] = useState("");

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const onSubmit = async (event) => {
        event.preventDefault();

        console.log(contact_key);

        setResult("Sending....");

        const formData = new FormData(event.target);

        formData.append("access_key", contact_key);

        const response = await fetch(
            "https://api.web3forms.com/submit",
            {
                method: "POST",
                body: formData,
            }
        );

        const data = await response.json();

        if (data.success) {
            setResult("");

            setFormData({
                name: "",
                email: "",
                message: "",
            });

            toast.success("Form Submitted Successfully");

            event.target.reset();
        } else {
            console.log("Error", data);

            toast.error(data.message);

            setResult("");
        }
    };

    return (
        <section className="contactBox" id="contactUs">
            <div className="contactHeader">
                <span className="contactEyebrow">
                    Get in touch
                </span>

                <h2 className="contactTitle">
                    <span className="contactTitleLight">
                        Contact
                    </span>

                    <span className="contactTitleBold">
                        Us
                    </span>
                </h2>
            </div>

            <div className="contactGrid">

                {/* LEFT CARD */}
                <motion.div
                    className="contactInfoCard"
                    initial={{
                        opacity: 0,
                        x: -60,
                    }}
                    whileInView={{
                        opacity: 1,
                        x: 0,
                    }}
                    viewport={{
                        once: true,
                        margin: "-80px",
                    }}
                    transition={{
                        duration: 0.8,
                        ease: "easeOut",
                    }}
                >
                    <span className="contactInfoEyebrow">
                        Reach us
                    </span>

                    <p className="contactInfoLead">
                        Have a question about our chimneys,
                        cooktops, or an ongoing order?
                        We&rsquo;re happy to help.
                    </p>

                    <div className="contactInfoRows">

                        <a
                            className="contactInfoRow"
                            href="tel:+919898540840"
                        >
                            <span className="contactInfoIcon">
                                <PhoneIcon />
                            </span>

                            +91 98985 40840
                        </a>

                        <a
                            className="contactInfoRow"
                            href="mailto:sata.inernational91@gmail.com"
                        >
                            <span className="contactInfoIcon">
                                <MailIcon />
                            </span>

                            sata.inernational91@gmail.com
                        </a>

                        <div className="contactInfoRow contactInfoAddress">
                            <span className="contactInfoIcon">
                                <PinIcon />
                            </span>

                            Plot No. 37, Valinath Society,
                            U-M Road, Bhatar, Surat 395001,
                            Gujarat, India
                        </div>

                    </div>
                </motion.div>

                {/* RIGHT CARD */}
                <motion.div
                    className="contactFormCard"
                    initial={{
                        opacity: 0,
                        x: 60,
                    }}
                    whileInView={{
                        opacity: 1,
                        x: 0,
                    }}
                    viewport={{
                        once: true,
                        margin: "-80px",
                    }}
                    transition={{
                        duration: 0.8,
                        ease: "easeOut",
                        delay: 0.15,
                    }}
                >
                    <span className="contactFormEyebrow">
                        Send a message
                    </span>

                    <p className="contactFormLead">
                        Tell us about your kitchen and we&rsquo;ll
                        get back to you shortly.
                    </p>

                    <form
                        onSubmit={onSubmit}
                        className="contactForm"
                        noValidate
                    >

                        <div className="formGroup">
                            <label htmlFor="contact-name">
                                Your Name
                            </label>

                            <input
                                id="contact-name"
                                type="text"
                                name="name"
                                placeholder="Your name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="formGroup">
                            <label htmlFor="contact-email">
                                Your Email
                            </label>

                            <input
                                id="contact-email"
                                type="email"
                                name="email"
                                placeholder="you@email.com"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="formGroup">
                            <label htmlFor="contact-message">
                                Message
                            </label>

                            <textarea
                                id="contact-message"
                                name="message"
                                placeholder="How can we help?"
                                value={formData.message}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <button
                            type="submit"
                            className="contactSubmitBtn"
                        >
                            <span>Send Message</span>
                            <ArrowIcon />
                        </button>

                        <span
                            className="formStatus"
                            role="status"
                        >
                            {result}
                        </span>

                    </form>
                </motion.div>

            </div>
        </section>
    );
};

export default Contact;